import api from "./axios";

export const createReferral = (payload) =>
  api.post("/api/v1/referrals", payload).then((r) => r.data);

export const createPatientReferral = (payload) =>
  api.post("/api/v1/referrals/patient", payload).then((r) => r.data);

export const createReferralDraft = (payload) =>
  api.post("/api/v1/referrals/drafts", payload).then((r) => r.data);

export const createPatientReferralDraft = (payload) =>
  api.post("/api/v1/referrals/patient/drafts", payload).then((r) => r.data);

export const submitReferralDraft = (referralId) =>
  api.post(`/api/v1/referrals/${referralId}/submit`).then((r) => r.data);

export const getReferralsSent = (providerId) =>
  api.get(`/api/v1/referrals/provider/${providerId}/sent`).then((r) => r.data);

export const getReferralsReceived = (providerId) =>
  api
    .get(`/api/v1/referrals/provider/${providerId}/received`)
    .then((r) => r.data);

export const getReferralsByPatient = (patientId) =>
  api.get(`/api/v1/referrals/patient/${patientId}`).then((r) => r.data);

export const getReferralPacket = (referralId) =>
  api.get(`/api/v1/referrals/${referralId}/packet`).then((r) => r.data);

export const getReferralCandidates = (referralId) =>
  api.get(`/api/v1/referrals/${referralId}/candidates`).then((r) => r.data);

export const getReferralOfferedSlots = (referralId) =>
  api
    .get(`/api/v1/referrals/${referralId}/appointment-offers`)
    .then((r) => r.data);

export const acceptReferral = (referralId, specialistProviderId) =>
  api
    .patch(`/api/v1/referrals/${referralId}/accept`, null, {
      params: { specialistProviderId },
    })
    .then((r) => r.data);

export const declineReferral = (referralId, specialistProviderId, reason) =>
  api
    .patch(
      `/api/v1/referrals/${referralId}/decline`,
      { reason },
      {
        params: { specialistProviderId },
      },
    )
    .then((r) => r.data);

export const requestMoreInfo = (referralId, specialistProviderId, note) =>
  api
    .patch(
      `/api/v1/referrals/${referralId}/request-info`,
      { note },
      {
        params: { specialistProviderId },
      },
    )
    .then((r) => r.data);

export const selectSpecialist = (referralId, providerId) =>
  api
    .post(`/api/v1/referrals/${referralId}/select-provider`, { providerId })
    .then((r) => r.data);

export const selectAppointmentSlot = (
  referralId,
  { slotStart, appointmentReason, memberId, appointmentType },
) =>
  api
    .post(`/api/v1/referrals/${referralId}/select-appointment`, {
      slotStart,
      appointmentReason,
      ...(memberId ? { memberId } : {}),
      ...(appointmentType ? { appointmentType } : {}),
    })
    .then((r) => r.data);

export const markAppointmentScheduled = (referralId) =>
  api
    .patch(`/api/v1/referrals/${referralId}/mark-scheduled`)
    .then((r) => r.data);

export const getReferralDocuments = (referralId) =>
  api.get(`/api/v1/documents/referral/${referralId}`).then((r) => r.data);

export const viewDocumentInline = (documentId) =>
  api
    .get(`/api/v1/documents/${documentId}/view`, { responseType: "blob" })
    .then((r) => URL.createObjectURL(r.data));

export const closeReferral = (referralId) =>
  api.patch(`/api/v1/referrals/${referralId}/close`).then((r) => r.data);

export const completeReferral = (referralId) =>
  api.patch(`/api/v1/referrals/${referralId}/complete`).then((r) => r.data);

export const cancelReferral = (referralId, reason) =>
  api
    .patch(`/api/v1/referrals/${referralId}/cancel`, { reason })
    .then((r) => r.data);

export const dispatchReferralFax = (referralId) =>
  api.post(`/api/v1/referrals/${referralId}/dispatch-fax`);

export const uploadReferralDocument = (
  referralId,
  file,
  category,
  providerId,
) => {
  const form = new FormData();
  form.append("file", file);
  form.append("category", category);
  form.append("providerId", String(providerId));
  return api
    .post(`/api/v1/referrals/${referralId}/documents`, form)
    .then((r) => r.data);
};

export const uploadPatientReferralDocument = (referralId, file, category) => {
  const form = new FormData();
  form.append("file", file);
  form.append("category", category);
  return api
    .post(`/api/v1/referrals/${referralId}/patient-documents`, form)
    .then((r) => r.data);
};

export const getNotificationsForProvider = (providerId) =>
  api.get(`/api/v1/notifications/provider/${providerId}`).then((r) => r.data);

export const getNotificationsForPatient = (patientId) =>
  api.get(`/api/v1/notifications/patient/${patientId}`).then((r) => r.data);

export const markNotificationRead = (notificationId) =>
  api
    .post(`/api/v1/notifications/${notificationId}/mark-read`)
    .then((r) => r.data);
